import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { A11yModule } from '@angular/cdk/a11y';
import { MaterialModule } from 'src/@prep/shared/material-components.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PostLoginDepartmentDialogComponent } from './post-login-department-dialog.component';

@NgModule({
  declarations: [PostLoginDepartmentDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    A11yModule,
    NgxMatSelectSearchModule
  ],
  exports: [PostLoginDepartmentDialogComponent]
})
export class PostLoginDepartmentDialogModule { }